export default __webpack_public_path__ + "static/media/work.1948bdf6.svg";